import React, { useContext, useState, useEffect } from 'react';
import { dbPost } from '../../apis/commonApi';
import { GlobalContext } from '../../components/contexts';
import { nlPost } from '../../apis/notLoginApi';

const PayMethod = () => {
  useEffect(() => {
    document.title = '결제 수단';
  }, []);

  const { store } = useContext(GlobalContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cardCompanies, setCardCompanies] = useState([]);
  const [agreeAll, setAgreeAll] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [individualAgreements, setIndividualAgreements] = useState({
    terms0: false,
    terms1: false,
    terms2: false,
    terms3: false,
  });

  const handleModalClose = () => {
    setIsModalOpen(false);
    setIndividualAgreements({
      terms0: false,
      terms1: false,
      terms2: false,
      terms3: false,
    });
    setAgreeAll(false);

    document.querySelectorAll('.modal-conts input').forEach(input => {
      input.value = '';
    });
    document.querySelectorAll('.modal-conts select').forEach(select => {
      select.value = '';
    });
  };

  const fetchCardCompanies = async () => {
    try {
      const url = '/pay/card/list.do';
      const response = await dbPost(url, {});
      setCardCompanies(response);
    } catch (error) {
      setCardCompanies([]);
    }
  };

  const fetchPaymentMethods = async () => {
    try {
      const url = '/pay/method/list.do';
      const response = await nlPost(url, { entSn: store?.entSn });
      setPaymentMethods(response);
    } catch (error) {
      setPaymentMethods([]);
    }
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchCardCompanies();
    fetchPaymentMethods();
  }, []);

  const handleIndividualAgreementChange = key => {
    const newAgreements = {
      ...individualAgreements,
      [key]: !individualAgreements[key],
    };

    setIndividualAgreements(newAgreements);

    const allChecked = Object.values(newAgreements).every(value => value);
    setAgreeAll(allChecked);
  };

  const handleAgreeAllChange = () => {
    const newAgreeAll = !agreeAll;
    setAgreeAll(newAgreeAll);

    setIndividualAgreements({
      terms0: newAgreeAll,
      terms1: newAgreeAll,
      terms2: newAgreeAll,
      terms3: newAgreeAll,
    });
  };

  const handleDeletePaymentMethod = async stlmMthdId => {
    if (!confirm('해당 결제수단을 삭제하시겠습니까?')) {
      return;
    }

    try {
      const url = '/pay/method/delete.do';
      await dbPost(url, { stlmMthdId });

      alert('결제수단이 성공적으로 삭제되었습니다.');
      fetchPaymentMethods();
    } catch (error) {
      alert('결제수단 삭제에 실패했습니다.');
    }
  };

  const updateDefaultPayment = async newDefaultId => {
    try {
      const oldDefault = paymentMethods.find(method => method.bscUseYn === 'Y');
      const oldDefaultId = oldDefault?.stlmMthdId;
      const url = '/pay/defaultPayment/update.do';

      await dbPost(url, { oldDefaultId, newDefaultId });

      fetchPaymentMethods();
    } catch (error) {}
  };

  const handleRegisterPaymentMethod = async () => {
    try {
      const cardNo = Array.from(
        document.querySelectorAll('.modal-conts input[type="text"]')
      )
        .slice(0, 4)
        .map(input => input.value.trim())
        .join('');

      const ownerBrdt = [
        document.getElementById('sel2').value,
        document.getElementById('sel3').value,
        document.getElementById('sel4').value,
      ]
        .map(value => value.trim())
        .join('');

      const cardVldYm = [
        document.getElementById('sel5').value,
        document.getElementById('sel6').value,
      ]
        .map(value => value.trim())
        .join('');

      const cardEntCd = document.getElementById('sel1').value;

      const idntfNm = document
        .querySelector('.modal-conts input[placeholder="별칭을 입력해주세요."]')
        .value.trim();
      const ownerNm = document
        .querySelector(
          '.modal-conts input[placeholder="소유자의 이름을 입력해주세요."]'
        )
        .value.trim();

      const payload = {
        cardEntCd,
        cardNo,
        idntfNm,
        ownerNm,
        ownerBrdt,
        cardVldYm,
        entSn: store?.entSn,
        prvcUtlzAgreYn: 'Y',
        cardEntTdptyPvsnAgreYn: 'Y',
        prvcClctStmlSvcEntPvsnAgreYn: 'Y',
        prvcClctTdptyPvsnAgreYn: 'Y',
      };

      const url = '/pay/method/create.do';
      await dbPost(url, payload);

      alert('결제수단이 성공적으로 등록되었습니다.');
      // setIsModalOpen(false);
      fetchPaymentMethods();
      handleModalClose();
    } catch (error) {
      alert('결제수단 등록에 실패했습니다.');
    }
  };

  const isAllInputsFilled = () => {
    const inputs = [
      document.getElementById('sel1').value.trim(),
      ...Array.from(
        document.querySelectorAll('.modal-conts input[type="text"]')
      )
        .slice(0, 4)
        .map(input => input.value.trim()),
      document
        .querySelector('.modal-conts input[placeholder="별칭을 입력해주세요."]')
        .value.trim(),
      document
        .querySelector(
          '.modal-conts input[placeholder="소유자의 이름을 입력해주세요."]'
        )
        .value.trim(), // 이름
      document.getElementById('sel2').value.trim(),
      document.getElementById('sel3').value.trim(),
      document.getElementById('sel4').value.trim(),
      document.getElementById('sel5').value.trim(),
      document.getElementById('sel6').value.trim(),
    ];

    return inputs.every(value => value !== '');
  };

  const isRegisterButtonDisabled =
    !Object.values(individualAgreements).every(value => value) ||
    !isAllInputsFilled();

  const generateYears = (start, end) =>
    Array.from({ length: end - start + 1 }, (_, i) => start + i);
  const generateNumbers = (start, end) =>
    Array.from({ length: end - start + 1 }, (_, i) =>
      String(start + i).padStart(2, '0')
    );

  const years = generateYears(1950, 2025);
  const months = generateNumbers(1, 12);
  const days = generateNumbers(1, 31);
  const cardYears = generateNumbers(0, 99);

  return (
    <>
      <div>
        <div className="contents">
          <div className="page-title-wrap" data-type="responsive">
            <h2 className="h-tit">결제수단</h2>
          </div>
          <div className="payment-wrap">
            {paymentMethods.map(method => (
              <div
                key={method.stlmMthdId}
                className={`payment-item ${
                  method.bscUseYn === 'Y' ? 'basic' : ''
                }`}
              >
                {method.bscUseYn === 'Y' && (
                  <span className="krds-badge bg-3">기본결제수단</span>
                )}
                <p className="payment-title">{method.idntfNm}</p>
                {method.bscUseYn === 'N' && (
                  <div className="page-btn-wrap">
                    <button
                      type="button"
                      className="btn sm"
                      onClick={() => updateDefaultPayment(method.stlmMthdId)}
                    >
                      기본 결제수단 설정
                    </button>
                    <button
                      type="button"
                      className="btn sm secondary"
                      onClick={() =>
                        handleDeletePaymentMethod(method.stlmMthdId)
                      }
                    >
                      결제수단 삭제
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="page-btn-wrap">
            <button
              type="button"
              className="btn xlg tertiary open-modal"
              onClick={handleModalOpen}
            >
              새로운 결제수단 등록
            </button>
          </div>
        </div>

        <section
          id="modal_sample_03"
          className={`modal fade ${isModalOpen ? 'shown in' : ''}`}
          aria-hidden={!isModalOpen}
          role="dialog"
          aria-labelledby="tit_modal_sample_03"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h2 id="tit_modal_sample_03" className="modal-title">
                  결제수단 등록
                </h2>
              </div>
              <div className="modal-conts">
                <div className="tbl-wrap">
                  <h3 className="block-tit">결제수단 정보</h3>
                  <table className="tbl data row">
                    <caption>
                      결제 수단 저장을 위한 정보 입력 테이블입니다.
                    </caption>
                    <tbody>
                      <tr>
                        <th scope="row">카드사</th>
                        <td>
                          <div className="input-group">
                            <label className="hidden-label" htmlFor="sel1">
                              카드사 선택
                            </label>
                            <select id="sel1" className="form-select md">
                              <option value="">카드사 선택</option>
                              {cardCompanies.map(company => (
                                <option
                                  key={company.comCd}
                                  value={company.comCd}
                                >
                                  {company.comCdNm}
                                </option>
                              ))}
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">카드번호</th>
                        <td>
                          <div className="input-group">
                            {[...Array(4)].map((_, idx) => (
                              <>
                                <label className="hidden-label" htmlFor={idx}>
                                  카드 번호 입력
                                </label>
                                <input
                                  key={idx}
                                  id={idx}
                                  type="text"
                                  className="form-control md"
                                  maxLength={4}
                                  placeholder="****"
                                  onInput={e => {
                                    e.target.value = e.target.value.replace(
                                      /[^0-9]/g,
                                      ''
                                    );
                                  }}
                                />
                              </>
                            ))}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">별칭</th>
                        <td>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control md"
                              placeholder="별칭을 입력해주세요."
                              aria-labelledby="cardAlias"
                              id="cardAlias"
                            />
                            <label className="hidden-label" htmlFor="cardAlias">
                              카드 별칭
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">이름</th>
                        <td>
                          <div className="input-group">
                            <label className="hidden-label" htmlFor="ownerNm">
                              소유자 이름 입력
                            </label>
                            <input
                              type="text"
                              className="form-control md"
                              placeholder="소유자의 이름을 입력해주세요."
                              aria-labelledby="ownerNm"
                              id="ownerNm"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">생년월일</th>
                        <td>
                          <div className="input-group">
                            <label className="hidden-label" htmlFor="sel2">
                              생년월일 년도
                            </label>
                            <select
                              id="sel2"
                              className="form-select md"
                              aria-labelledby="sel2"
                            >
                              <option value="">YYYY</option>
                              {years.map(year => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                            <label className="hidden-label" htmlFor="sel3">
                              생년월일 월
                            </label>
                            <select
                              id="sel3"
                              className="form-select md"
                              aria-labelledby="sel3"
                            >
                              <option value="">MM</option>
                              {months.map(month => (
                                <option key={month} value={month}>
                                  {month}
                                </option>
                              ))}
                            </select>
                            <label className="hidden-label" htmlFor="sel4">
                              생년월일 일
                            </label>
                            <select
                              id="sel4"
                              className="form-select md"
                              aria-labelledby="sel4"
                            >
                              <option value="">DD</option>
                              {days.map(day => (
                                <option key={day} value={day}>
                                  {day}
                                </option>
                              ))}
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">카드 유효기간</th>
                        <td>
                          <div className="input-group">
                            <label className="hidden-label" htmlFor="sel5">
                              카드 유효기간 월
                            </label>
                            <select
                              id="sel5"
                              className="form-select md"
                              aria-labelledby="sel5"
                            >
                              <option value="">MM</option>
                              {months.map(month => (
                                <option key={month} value={month}>
                                  {month}
                                </option>
                              ))}
                            </select>{' '}
                            <label className="hidden-label" htmlFor="sel6">
                              카드 유효기간 연도
                            </label>
                            <select
                              id="sel6"
                              className="form-select md"
                              aria-labelledby="sel6"
                            >
                              <option value="">YY</option>
                              {cardYears.map(year => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <ul className="agree-box">
                  <li>
                    <span className="txt">
                      카드사 개인정보 제3자 제공 동의 (필수)
                    </span>
                    <div className="chk-area">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="card_check"
                          checked={individualAgreements.terms0}
                          onChange={() =>
                            handleIndividualAgreementChange('terms0')
                          }
                        />
                        <label htmlFor="card_check">동의함</label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <span className="txt">개인정보 제3자 동의 (필수)</span>
                    <div className="chk-area">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="terms_check"
                          checked={individualAgreements.terms1}
                          onChange={() =>
                            handleIndividualAgreementChange('terms1')
                          }
                        />
                        <label htmlFor="terms_check">동의함</label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <span className="txt">
                      결제 서비스 업체 제공 동의 (필수)
                    </span>
                    <div className="chk-area">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="terms_check2"
                          checked={individualAgreements.terms2}
                          onChange={() =>
                            handleIndividualAgreementChange('terms2')
                          }
                        />
                        <label htmlFor="terms_check2">동의함</label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <span className="txt">개인정보 취급 동의 (필수)</span>
                    <div className="chk-area">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="terms_check3"
                          checked={individualAgreements.terms3}
                          onChange={() =>
                            handleIndividualAgreementChange('terms3')
                          }
                        />
                        <label htmlFor="terms_check3">동의함</label>
                      </div>
                    </div>
                  </li>
                  <li className="agree-all">
                    <span className="txt">아래 약관에 모두 동의합니다.</span>
                    <div className="chk-area">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="all_check"
                          checked={agreeAll}
                          onChange={handleAgreeAllChange}
                        />
                        <label htmlFor="all_check">모두 동의</label>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="modal-btn btn-wrap both">
                <button
                  type="button"
                  className="btn md"
                  onClick={handleModalClose}
                >
                  취소
                </button>
                <button
                  type="button"
                  className="btn md primary"
                  disabled={isRegisterButtonDisabled}
                  onClick={handleRegisterPaymentMethod}
                >
                  결제수단 등록
                </button>
              </div>
            </div>
          </div>
          <div className="modal-back in"></div>
        </section>
      </div>
    </>
  );
};

export default PayMethod;
